/**
 * This return the name of the space from team object, saying if it is a team, org, or child-org
 * @param team
 * @returns {string}
 */
export default team => {
  if (team.isOrgLike) {
    if (team.parentId) {
      return 'Child Org'
    } else {
      return 'Org'
    }
  } else {
    return 'Team'
  }
}
